ACC.emailVerification = {
  cboxLoadedContent: '#cboxLoadedContent',
  emailaddressCheck: '.ph-emailaddress_check',
  resendClickCount: 0,
  disableResendButton: function() {
    sessionStorage.setItem('resendDisabledTime', new Date());

    $('.ph-maxresenderror').show();
    $('.ph-registration__emailresend').addClass('ph-resend_disabled');

    var maxResendMinutes = parseInt(0 + $('#maxResendMinutes').val(), 10);

    if (maxResendMinutes <= 0) {
      maxResendMinutes = 15;
    }

    maxResendMinutes = (60 * maxResendMinutes) * 1000;
    ACC.emailVerification.enableResendAfterTime(maxResendMinutes);
  },
  includeEmailinUrl: function(emailAddress) {
    if ($('.ph-oneIdLoginUrl').length > 0) {
      var oneIdLoginUrl = $('.ph-oneIdLoginUrl').attr('href');

      oneIdLoginUrl = oneIdLoginUrl + '&userID=' + emailAddress;
      $('.ph-oneIdLoginUrl').attr('href', oneIdLoginUrl);
    }
  },
  addhtml: function() {
    if (ACC.header.$loginRegRedirect.length > 0) {
      return $('.ph-emailexists__parent').html();
    }

    return $('.ph-emailexists__wrapper').html();
  },
  sendPasscode: function(emailInput, pageName) {
    $('.ph-emailpasscodesent_msg1,.ph-emailpasscodeverify_msg').hide();
    $('.ph-otpcheckfieldwrap').removeClass('ph-form_field_error');
    $('.ph-passcode_check').val('');

    var maxResendCount = parseInt(0 + $('#maxResendCount').val(), 10);

    if (maxResendCount < 1) {
      maxResendCount = 5;
    }

    if (pageName === 'send') {
      maxResendCount = ACC.emailVerification.resendClickCount + 1;
    }

    if (ACC.emailVerification.resendClickCount < maxResendCount) {
      $.ajax({
        url: ACC.config.contextPath + '/otp/send',
        type: 'POST',
        data: {
          email: emailInput
        },
        success: function(result) {
          if (result) {
            $('.ph-registration__emailcheck').hide();

            if (pageName === 'send') {
              $('.ph-registration__emailverify').show();
            }

            $('.ph-emailpasscodesent_msg1').html(result.message + ' <b>' + emailInput + '</b>').show();
            $('.ph-emailpasscodeverify_msg').html($('.message-enterpasscode').html() + ' <b>' + emailInput + '</b>').show();
          }
        }
      });

      if (pageName === 'resend') {
        ACC.emailVerification.resendClickCount = ACC.emailVerification.resendClickCount + 1;
      }
    } else if (pageName === 'resend' && !$('.ph-registration__emailresend').hasClass('ph-resend_disabled')) {
      ACC.emailVerification.disableResendButton();
    } else if (pageName === 'resend') {
      $('.ph-maxresenderror').show();
    }
  },
  otpValidation: function(emailInput, otpEntered) {
    $('.ph-otpcheckfieldwrap').removeClass('ph-form_field_error');
    $.ajax({
      url: ACC.config.contextPath + '/otp/validate',
      type: 'POST',
      data: {
        email: emailInput,
        otp: otpEntered
      },
      success: function(result) {
        if (result.status === true) {
          $('.ph-registration__otp').hide();
          $('.ph-registration__otpsuccess').show();
          $('.regVerifiedEmail').text(emailInput);
          sessionStorage.setItem('registerEmailInput', 'true');
          sessionStorage.setItem('registerEmailValue', emailInput);
        } else {
          $('.ph-otpcheckfieldwrap').addClass('ph-form_field_error');
          $('.ph-emailpasscodeverify__input .ph-register__emptyvalue').html(result.message);
        }
      }
    });
  },
  otpSuccessPage: function(emailInput) {
    $('.ph-registration__otpsuccess').hide();
    $('#emailAddressId').val(emailInput).addClass('ph-disabled_inputfield').attr('readonly', 'readonly');
    location.hash = 'personalinfo';
  },
  otpSuccessPageCheckout: function(emailInput) {
    $('.ph-anonymous_shipping_email').hide();
    $('.ph-anonymous_shipping_form,.ph-anonymousshipping__proceed').show();
    $('.checkoutEmailAddress').val(emailInput).addClass('ph-disabled_inputfield').attr('readonly', 'readonly');
    ACC.anonymouscheckout.showShippingSection();
  },
  emailExistPopup: function(emailInput) {
    $('.ph-reg_username').val(emailInput).attr('value', emailInput);
    $.colorbox({
      html: ACC.emailVerification.addhtml(),
      width: '100%',
      maxHeight: '80%',
      maxWidth: '522px',
      close: '<button type=\'button\' id=\'ph-cboxClose\' class=\'ph-favclose\'><span class=\'ph-icon-cross ph-favcross\'></span></button>',
      overlayClose: false,
      onComplete: function() {
        ACC.common.refreshScreenReaderBuffer();
      },
      onClosed: function() {
        ACC.common.refreshScreenReaderBuffer();
      }
    });
  },
  forgotpassword: function() {
    var emailInput = $.trim($(ACC.emailVerification.emailaddressCheck).val());

    $('.ph-forgottenPwd__mailid').text(emailInput);
    $(ACC.emailVerification.cboxLoadedContent).find('.ph-emailexists__container').hide();
    $.ajax({
      url: ACC.config.contextPath + '/login/pw/emailIDCheck',
      type: 'GET',
      data: {
        emailId: emailInput,
        diffUrl: false
      },
      async: false,
      dataType: 'json',
      success: function() {
        $.colorbox({
          inline: true,
          href: '#validEmailPopup',
          width: '100%',
          maxHeight: '400px',
          maxWidth: '522px',
          close: '<button type=\'button\' id=\'ph-cboxClose\' class=\'ph-favclose\'><span class=\'ph-icon-cross ph-favcross\'></span></button>',
          overlayClose: false,
          onComplete: function() {
            ACC.common.refreshScreenReaderBuffer();
            $(document).find('.ph-verifyforgotPwd .newforgottenPwdEmail').val(emailInput);
            $(document).find('.ph-verifyforgotPwd .newforgottenPwdForm').ajaxSubmit();
          },
          onClosed: function() {
            ACC.common.refreshScreenReaderBuffer();
          }
        });
      }
    });
  },
  doLoginfromReg: function() {
    var $logPass = $(ACC.emailVerification.cboxLoadedContent).find('#reg_password');

    $logPass.parent().removeClass('ph-form_field_error');

    if ($logPass.val()) {
      $('.ph-loginemailinput').val($(ACC.emailVerification.emailaddressCheck).val());
      $('#j_password').val($logPass.val());
      $('.ph-login_login').trigger('click');
      $.colorbox.close();
      $('.ph-loader__default').show();
    } else {
      $logPass.parent().addClass('ph-form_field_error');
    }
  },
  emailCheckValidation: function() {
    var isEmailError = true;

    if (ACC.anonymouscheckout.emailFieldCheck(true)) {
      isEmailError = false;
    }

    return isEmailError;
  },
  emailCheckButtonClick: function() {
    var emailInput = $.trim($(ACC.emailVerification.emailaddressCheck).val());
    var isEmailError = ACC.emailVerification.emailCheckValidation();

    if (isEmailError === false) {
      $.ajax({
        dataType: 'json',
        url: ACC.config.contextPath + '/register/validateUserId',
        type: 'GET',
        data: {
          emailId: emailInput
        },
        success: function(result) {
          if (result === false) {
            ACC.emailVerification.sendPasscode(emailInput, 'send');
          } else {
            ACC.emailVerification.emailExistPopup(emailInput);
          }
        }
      });
    }
  },
  emailCheckPage: function() {
    sessionStorage.setItem('registerEmailInput', false);
    sessionStorage.setItem('registerEmailValue', '');
    $('.ph-registration__emailcheck').show();

    if (location.hash !== '') {
      location.hash = '';
    }

    $(document).on('click', '.ph-regforgotPassword', function() {
      ACC.emailVerification.forgotpassword();
    });
    $(document).on('click', '.ph-reg_loginbutton', function() {
      ACC.emailVerification.doLoginfromReg();
    });
    $(document).on('click', '.ph-registration__emailcontinue', function(event) {
      $('.ph-registration__emailcheck').hide();
      $('.ph-registration__emailverify').hide();
      $('.ph-registration__otp').show();
      $('.ph-maxresenderror').hide();
      event.preventDefault();
    });
    $(document).on('click', '.ph-registration__emailcancel', function() {
      $('.ph-registration__emailcheck').show();
      $('.ph-registration__emailverify').hide();
      $('.ph-maxresenderror').hide();
    });
    $(document).on('click', '.ph-registration__emailresend', function() {
      var emailInput = $.trim($(ACC.emailVerification.emailaddressCheck).val());

      ACC.emailVerification.sendPasscode(emailInput, 'resend');
    });
    $(document).on('click', '.ph-registration__emailcontinue2', function(event) {
      var emailInput = $.trim($(ACC.emailVerification.emailaddressCheck).val()),
          otpEntered = $.trim($('.ph-passcode_check').val());

      if (otpEntered) {
        ACC.emailVerification.otpValidation(emailInput, otpEntered);
      } else {
        $('.ph-otpcheckfieldwrap').addClass('ph-form_field_error');
      }

      event.preventDefault();
    });
    $(document).on('click', '.ph-registration__emailcancel2', function() {
      $('.ph-registration__otp').hide();
      $('.ph-registration__emailverify').show();
      $('.ph-maxresenderror').hide();
    });
    $(document).on('click', '.ph-anonymouscheckout__emailNext', function(event) {
      var emailInput = $.trim($(ACC.emailVerification.emailaddressCheck).val());

      ACC.emailVerification.otpSuccessPageCheckout(emailInput);
      event.preventDefault();
    });
    $(document).on('click', '.ph-registration__emailNext', function(event) {
      var emailInput = $.trim($(ACC.emailVerification.emailaddressCheck).val());

      ACC.emailVerification.otpSuccessPage(emailInput);
      event.preventDefault();
    });
    $(document).on('blur', '#reg_password', function() {
      var $logPass = $(ACC.emailVerification.cboxLoadedContent).find('#reg_password');

      if ($logPass.val()) {
        $logPass.parent().removeClass('ph-form_field_error');
      }
    });
    $(document).on('keydown', '.ph-emailaddress_check', function(keyevent) {
      if (keyevent.keyCode === 13) {
        $('.ph-registration__passcode').trigger('click');
      }
    });
    $(document).on('keydown', '.ph-passcode_check', function(keyevent) {
      if (keyevent.keyCode === 13) {
        $('.ph-passcode_check').trigger('blur');
        $('.ph-registration__emailcontinue2').trigger('click');
      }
    });
    ACC.emailVerification.resendButtonActivity();
    ACC.emailVerification.initBind();
  },
  initBind: function() {
    $(document).on('click', '.ph-registration__passcode', function(event) {
      ACC.emailVerification.emailCheckButtonClick();
      event.preventDefault();
    });
    $(document).on('blur', '.ph-emailaddress_check', function() {
      ACC.emailVerification.emailCheckValidation();
    });
    $(document).on('blur', '.ph-passcode_check', function() {
      var otpEntered = $.trim($('.ph-passcode_check').val());

      if (otpEntered) {
        $('.ph-otpcheckfieldwrap').removeClass('ph-form_field_error');
      } else {
        $('.ph-otpcheckfieldwrap').addClass('ph-form_field_error');
      }
    });
  },
  resendButtonActivity: function() {
    var resendDisabledTime = sessionStorage.getItem('resendDisabledTime');

    if (resendDisabledTime) {
      var maxResendMinutes = parseInt(0 + $('#maxResendMinutes').val(), 10);

      if (maxResendMinutes <= 0) {
        maxResendMinutes = 15;
      }

      var maxResendCount = parseInt(0 + $('#maxResendCount').val(), 10);

      if (maxResendCount < 1) {
        maxResendCount = 5;
      }

      var newDateObj = new Date(resendDisabledTime);
      var currentDateObj = new Date();

      newDateObj.setTime(newDateObj.getTime() + (maxResendMinutes * 60 * 1000));

      if (currentDateObj < newDateObj) {
        var diffTime = newDateObj.getTime() - currentDateObj.getTime();

        ACC.emailVerification.resendClickCount = maxResendCount;
        $('.ph-registration__emailresend').addClass('ph-resend_disabled');
        ACC.emailVerification.enableResendAfterTime(diffTime);
      }
    }
  },
  enableResendAfterTime: function(timeValue) {
    setTimeout(function() {
      $('.ph-maxresenderror').hide();
      $('.ph-registration__emailresend').removeClass('ph-resend_disabled');
      ACC.emailVerification.resendClickCount = 0;
    }, timeValue);
  },
  isEmailVerified: function() {
    var emailVerified = false;

    if ($('.ph-salesrep').val() === 'true') {
      emailVerified = true;
    }

    if ($('#emailVerificationPage').val() !== 'true') {
      emailVerified = true;
    }

    if ($('.ph-salesrep').val() !== 'true' && sessionStorage.getItem('registerEmailInput') === 'true') {
      emailVerified = true;
      $('#emailAddressId,.checkoutEmailAddress').val(sessionStorage.getItem('registerEmailValue')).addClass('ph-disabled_inputfield').attr('readonly', 'readonly');
    }

    return emailVerified;
  },
  initRegisterPage: function() {
    if (ACC.emailVerification.isEmailVerified()) {
      location.hash = 'personalinfo';
      document.getElementById('firstName').focus();
      document.documentElement.scrollTop = 0;
      $(document).find('.ph-verifyforgotPwd').remove();
    } else {
      ACC.emailVerification.emailCheckPage();
    }
  },
  initCheckoutPage: function() {
    $('.ph-anonymous_shipping_loader').hide();

    if (ACC.emailVerification.isEmailVerified()) {
      $('.ph-anonymous_shipping_email').hide();
      $('.ph-anonymous_shipping_form,.ph-anonymousshipping__proceed').show();
    } else {
      $('.ph-anonymous_shipping_email').show();
      $('.ph-anonymous_shipping_form,.ph-anonymousshipping__proceed').hide();
      ACC.emailVerification.emailCheckPage();
    }
  }
};

$(document).ready(function() {
  if ($('.ph-page-register').length > 0) {
    ACC.emailVerification.initRegisterPage();
  }
});
